var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("bundle bundle-" + _vm.current_color)},[_vm._v(_vm._s(_vm.$t(("core.document.status." + _vm.value))))])}
var staticRenderFns = []

export { render, staticRenderFns }